// extracted by mini-css-extract-plugin
export default {"heading":"Brouchure_heading__yoOBz","brouchuresContainer":"Brouchure_brouchuresContainer__MP0B4"};